export function validateSortColumn(columns, sort) {
    const order = sort?.toString()?.replace(":asc","")?.replace(":desc","") || null;

    if(order === "modifiedDate" || order === "createdDate" )
        return true
    if (columns && order !== null && order !== undefined) {
        return columns?.some(element => element?.dataIndex === order && element?.sorter);
    }

    return true;
}

export const font_icon = 20